"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'migaloo',
    client_id: '07-tendermint-113',
    connection_id: 'connection-89'
  },
  chain_2: {
    chain_name: 'noble',
    client_id: '07-tendermint-19',
    connection_id: 'connection-28'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-60',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-14',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'migaloo',
    client_id: '07-tendermint-3',
    connection_id: 'connection-11'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2669',
    connection_id: 'connection-2171'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-5',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-642',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'migaloo',
    client_id: '07-tendermint-6',
    connection_id: 'connection-9'
  },
  chain_2: {
    chain_name: 'secretnetwork',
    client_id: '07-tendermint-116',
    connection_id: 'connection-87'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-57',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'migaloo',
    client_id: '07-tendermint-108',
    connection_id: 'connection-84'
  },
  chain_2: {
    chain_name: 'sei',
    client_id: '07-tendermint-22',
    connection_id: 'connection-13'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-57',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-14',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'migaloo',
    client_id: '07-tendermint-118',
    connection_id: 'connection-90'
  },
  chain_2: {
    chain_name: 'stargaze',
    client_id: '07-tendermint-352',
    connection_id: 'connection-287'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-69',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-269',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'migaloo',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'terra2',
    client_id: '07-tendermint-105',
    connection_id: 'connection-93'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-86',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }, {
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-87',
      port_id: 'wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'migaloo',
    client_id: '07-tendermint-104',
    connection_id: 'connection-83'
  },
  chain_2: {
    chain_name: 'umee',
    client_id: '07-tendermint-234',
    connection_id: 'connection-195'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-56',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-104',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}];
var _default = exports["default"] = info;